import {Message} from "primereact/message";
import {useTranslation} from "react-i18next";

import {selectOverriddenVariantAppreciationTitles} from "../../redux/appreciationsUtil";
import {useRevaSelector} from "../../redux/revaHooks";

/** Warns before finalizing that some variant appreciations (#18998) were manually overridden. */
export default function OverriddenVariantAppreciationsWarning() {
    const {t} = useTranslation();
    const titles: string[] = useRevaSelector(selectOverriddenVariantAppreciationTitles);

    if (!titles.length) return null;

    return (
        <Message
            severity="warn"
            text={t("appreciation.overriddenVariantsWarning", {list: titles.join(", ")})}
            className="block white-space-pre-line leading-normal"
        />
    );
}
